import React from "react";
import { Link } from "react-router-dom";
import {
  formatPhoneNumber,
  getConversationAvatarSrc,
} from "../utils";

export default function ConversationHeader({ userData, onJobLinkClick }) {
  if (!userData?.id) {
    return null;
  }

  return (
    <div className="messaging__chat-top">
      <div className="messaging__chat-wrapper">
        <div className="messaging__chat-avatar">
          {userData?.is_online !== null && userData?.is_online ? (
            <span className="messaging__item-online">
              <img src="/assets/icons/dot.svg" alt="" />
            </span>
          ) : (
            ""
          )}
          <img src={getConversationAvatarSrc(userData)} alt="avatar" />
        </div>
        <div>
          <p className="messaging__chat-name">
            {userData?.name ? userData?.name : userData?.technician_name}
          </p>
          {userData?.type === "customer_support" && (
            <div className="messaging__chat-links">
              <a
                href={`tel:${
                  userData?.support_number
                    ? userData?.support_number.replace("+1", "")
                    : userData?.technician_phone.replace("+1", "")
                }`}
                className="messaging__chat-link"
              >
                {formatPhoneNumber(
                  userData?.support_number
                    ? userData?.support_number
                    : userData?.technician_phone
                )}
              </a>
              <a
                href={`mailto:${
                  userData?.support_email
                    ? userData?.support_email
                    : userData?.technician_email
                }`}
                className="messaging__chat-link"
              >
                {userData?.support_email
                  ? userData?.support_email
                  : userData?.technician_email}
              </a>
            </div>
          )}
          {userData?.type === "job_customer_technician" && (
            <p className="messaging__chat-techId">Tech ID: {userData?.member_id}</p>
          )}
        </div>
      </div>
      {userData?.type !== "support" && (
        <div className="messaging__chat__job_container">
          <div className="messaging__chat-job">
            Verification Key: <p>{userData?.verification_key}</p>
          </div>
          {userData?.job_title && (
            <Link
              onClick={onJobLinkClick}
              to={`/jobs/${userData?.job_title}`}
              className="messaging__chat-job"
            >
              Job ID# <p>{userData?.job_title}</p>
              <img src="/assets/icons/arrow-left.png" alt="" />
            </Link>
          )}
        </div>
      )}
    </div>
  );
}
